import React, { forwardRef } from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { cn } from '../../lib/utils';
interface ButtonProps extends HTMLMotionProps<'button'> {
  variant?: 'primary' | 'secondary' | 'outline' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  href?: string;
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  variant = 'primary',
  size = 'md',
  children,
  href,
  onClick,
  ...props
}, ref) => {
  const variants = {
    primary: 'bg-amber-500 text-black hover:bg-amber-400 border-transparent shadow-[0_0_15px_rgba(245,158,11,0.3)] hover:shadow-[0_0_25px_rgba(245,158,11,0.5)]',
    secondary: 'bg-zinc-800 text-zinc-100 hover:bg-zinc-700 border-transparent',
    outline: 'bg-transparent text-amber-500 border border-amber-500/50 hover:bg-amber-500/10 hover:border-amber-500',
    danger: 'bg-red-600 text-white hover:bg-red-500 border-transparent shadow-[0_0_15px_rgba(239,68,68,0.3)]'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg font-bold uppercase tracking-wide'
  };
  const sharedClasses = cn('inline-flex items-center justify-center rounded-md font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2 focus:ring-offset-black disabled:opacity-50 disabled:pointer-events-none', variants[variant], sizes[size], className);
  if (href) {
    return <motion.a href={href} target="_blank" rel="noopener noreferrer" whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={sharedClasses} data-id="element-141">
          {children}
        </motion.a>;
  }
  return <motion.button ref={ref} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={sharedClasses} onClick={onClick} {...props} data-id="element-142">
        {children}
      </motion.button>;
});
Button.displayName = 'Button';